import { render, staticRenderFns } from "./LibraryFormatTemplate.vue?vue&type=template&id=8c849536&scoped=true&"
import script from "./LibraryFormatTemplate.vue?vue&type=script&lang=js&"
export * from "./LibraryFormatTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LibraryFormatTemplate.vue?vue&type=style&index=0&id=8c849536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c849536",
  null
  
)

export default component.exports